<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">

  <div class="row">
  <ol class="breadcrumb" style="padding: 10px 20px 0px;">
    <li><a href="#">Home</a></li>
    <li class="active">{{'calculator.pensionCalculator.heading' | translate}} </li>
  </ol>
  <div>
    <div class="row">
      <div class="col-md-12 section">
        <form [formGroup]="pensionCalcultorForm" novalidate (submit)="calculatePension()">
          <div class="card mb-3">
            <div class="card-header bg-transparent">
              <h5 style="margin: 0px;">{{'calculator.pensionCalculator.heading' | translate}}</h5>
            </div>
            <div class="card-body">
              <p class="card-title">{{'calculator.pensionCalculator.intro1' | translate}}<br>
                {{'calculator.pensionCalculator.intro2' | translate}}<br>
                {{'calculator.pensionCalculator.intro3' | translate}}</p>
              <div class="row">
                <div class="col-md-5 col-left-margin" style="margin-bottom: 10px;">
                    <div class="card mb-3">
                      <div class="card-header bg-transparent header-for-dark">
                        <h5 style="margin: 0;">{{'calculator.pensionCalculator.personalData' | translate}}</h5>
                      </div>
                      <div class="card-body" sty>
                        <label class="col-form-label"
                          for="cost-of-living">{{'calculator.pensionCalculator.col' | translate}}</label>
                        <input class="form-control text-center" id="cost-of-living" [textMask]="{mask: currMask}"
                          formControlName="costOfLiving" tooltip="{{'calculator.pensionCalculator.coltip' | translate}}"
                          triggers="focus" />

                        <label for="monthly-income"
                          class="col-form-label">{{'calculator.pensionCalculator.cmi' | translate}}</label>
                        <input class="form-control text-center" id="monthly-income" [textMask]="{mask: currMask}"
                          formControlName="monthlyIncome" />

                        <label class="col-form-label">{{'calculator.pensionCalculator.dob' | translate}} </label>
                        <my-date-picker name="mydate" class="text-center" style="text-align: center;"
                          [options]="myDatePickerOptions" [(ngModel)]="birthDate" required
                          formControlName="dateOfBirth">
                        </my-date-picker>

                        <label for="total-asset"
                          class="col-form-label collapsed">{{'calculator.pensionCalculator.psb' | translate}}</label>
                        <input class="form-control text-center" id="total-asset" [textMask]="{mask: currMask}"
                          formControlName="pensionSavingBalance"
                          tooltip="{{'calculator.pensionCalculator.psbtip' | translate}}" triggers="focus" />

                        <label for="other-saving"
                          class="col-form-label">{{'calculator.pensionCalculator.osb' | translate}}</label>
                        <input class="form-control text-center" id="other-saving" [textMask]="{mask: currMask}"
                          formControlName="otherSavingBalance"
                          tooltip="{{'calculator.pensionCalculator.osbtip' | translate}}" triggers="focus" />

                        <label for="current-total-contribution"
                          class="col-form-label">{{'calculator.pensionCalculator.tcyc' | translate}}</label>
                        <input class="form-control text-center" id="current-total-contribution"
                          [textMask]="{mask: currMask}" formControlName="totalCurrentMonthlyContribution"
                          tooltip="{{'calculator.pensionCalculator.tcyctip' | translate}}" triggers="focus" />
                      </div>
                    </div>
                </div>
                <div class="col-md-5 col-left-margin col-assumsi" style="margin-bottom: 10px;">
                    <div class="card mb-3">
                      <div class="card-header bg-transparent header-for-dark">
                        <h5 style="margin: 0px;">{{'calculator.pensionCalculator.interhead' | translate}}</h5>
                      </div>
                      <div class="card-body">
                        <label for="period-until-retirement"
                          class="col-form-label">{{'calculator.pensionCalculator.pa' | translate}}</label>
                        <input class="form-control text-center" type="text" id="period-until-retirement"
                          (keyup)="handlePensionAgeError($event)" [textMask]="{mask: yearMask}"
                          formControlName="retirementAge" tooltip="{{'calculator.pensionCalculator.patip' | translate}}"
                          triggers="focus" />
                        <div *ngIf="ageError"></div>
                        <div *ngIf="ageError">
                          <div class="alert alert-info">
                            {{'calculator.pensionCalculator.retireageError' | translate}}
                          </div>
                        </div>

                        <label for="desired-retirement-planned"
                          class="col-form-label">{{'calculator.pensionCalculator.la' | translate}}</label>
                        <input class="form-control text-center" type="text" id="desired-retirement-planned"
                          (keyup)="handleLifeExpectedError($event)" [textMask]="{mask: yearMask}"
                          formControlName="lifeExpected" tooltip="{{'calculator.pensionCalculator.latip' | translate}}"
                          triggers="focus" />
                        <div *ngIf="lifeExpectedError"></div>
                        <div *ngIf="lifeExpectedError">
                          <div class="alert alert-info">
                            {{'calculator.pensionCalculator.lifeexpectedError' | translate}}
                          </div>
                        </div>

                        <label for="inflation-rate-assumption"
                          class="col-form-label ">{{'calculator.pensionCalculator.ira' | translate}}</label>
                        <input class="form-control text-center" type="text" id="inflation-rate-assumption"
                          (keyup)="handleInflationRate($event)" [textMask]="{mask: numberMask}"
                          formControlName="inflationRate"
                          tooltip="{{'calculator.pensionCalculator.iratip' | translate}}" triggers="focus" />
                        <div *ngIf="inflationError"></div>
                        <div *ngIf="inflationError">
                          <div class="alert alert-info">
                            {{'calculator.pensionCalculator.inflationError' | translate}}
                          </div>
                        </div>

                        <label for="assumption-annual-development-results"
                          class="col-form-label">{{'calculator.pensionCalculator.aadr' | translate}}</label>
                        <input class="form-control text-center" type="text" id="assumption-annual-development-results"
                          (keyup)="handlePercentage($event,1)" [textMask]="{mask: numberMask}"
                          formControlName="annualDevResults"
                          tooltip="{{'calculator.pensionCalculator.aadrtip' | translate}}" triggers="focus" />

                        <label for="assumption-of-average-salary-increase"
                          class="col-form-label">{{'calculator.pensionCalculator.aasi' | translate}}</label>
                        <input class="form-control text-center" type="text" id="assumption-of-average-salary-increase"
                          (keyup)="handlePercentage($event,2)" [textMask]="{mask: numberMask}"
                          formControlName="avgSalaryIncYear" triggers="focus" />

                        <div class="row">
                          <p class="mandatoryField" style="margin-bottom: 10px; margin-top: 25px"><i>*
                              {{'calculator.pensionCalculator.mandatoryfield' | translate}}</i></p>
                        </div>
                      </div>
                    </div>
                  <div class="alert alert-danger alert-dismissable" *ngIf="error">
                    {{'calculator.pensionCalculator.serverError' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer bg-transparent">
              <div class="row">
                <div class="col-md-12 text-center" style="margin-bottom: 0px;">
                  <button type="submit" class="btn btn-primary marginTop"
                    [disabled]="!pensionCalcultorForm.valid||inflationError||ageError||lifeExpectedError">{{'calculator.pensionCalculator.cal' | translate}}</button>
                </div>
              </div>
            </div>
          </div>
        </form>
          <div class="marginTop" *ngIf="showPensionResult">
            <div class="card mb-3">
              <div class="card-header bg-transparent">
                <h5 style="margin: 0px;">{{'calculator.pensionCalculator.calculateheadeing'|translate}} </h5>
              </div>
              <div class="card-body">
                <div class="col-md-12 firstResultHeader" *ngIf="monthlyContribution">
                  <div class="col-md-6 firstSectionInitResult">
                    <p class="futureGap">{{'calculator.pensionCalculator.futureGap'|translate}}</p>
                    <img class="futureGapImg" src="assets/images/calcu1.png" alt="submit" />
                    <span class="futureGapResult"><strong style="font-size: 20px;">{{currencySymbol}}
                        &nbsp;{{calculatedPension.retirementIncomeLoss }}</strong>
                      </span>
                      <p class="futureGapNote"><span class="glyphicon glyphicon-asterisk"></span>{{'calculator.pensionCalculator.result1'|translate}} - {{'calculator.pensionCalculator.result4'|translate}}</p>
                  </div>
                  <div class="col-md-6 firstSectionInitResult">
                    <p class="futureGap">{{'calculator.pensionCalculator.addContribution'|translate}}</p>
                    <img class="futureGapImg" src="assets/images/calcu2.png" alt="submit" />
                    <span class="futureGapResult"><strong style="font-size: 20px;">{{currencySymbol}}
                        &nbsp;{{calculatedPension.monthlyContribution}}</strong></span>
                    <p class="additionalContribution">({{calculatedPension.additionalContributionReqPercentage}}%
                      {{'calculator.pensionCalculator.additionalContribution' |translate}})</p>
                      <p class="futureGapNote"><span class="glyphicon glyphicon-asterisk"></span>{{'calculator.pensionCalculator.additionalContributionNote' | translate}}</p>
                  </div>

                </div>
                <div class="col-md-12 firstResultHeader" *ngIf="noMonthlyContribution">
                  <div class="col-md-12 noContributionResult ">

                    <img class="futureGapImg" src="assets/images/calcu3.png" alt="submit" />
                    <span class="futureGapResult">{{'calculator.pensionCalculator.noContribution'|translate}}</span>

                  </div>
                </div>

                <div class="col-md-12 result-pannel" *ngIf="showDetailPensionResult">
                  <div class="form-group row" appToggle>
                  <div class="col-md-6">
                    <label class="col-form-label toggle-icon noMarginTop"><span>A -</span>{{'calculator.pensionCalculator.result1'|translate}}</label>
                    <p class="futureGapNote formula-section"><span class="glyphicon glyphicon-asterisk"></span>{{'calculator.pensionCalculator.result1'|translate}}</p>
                  </div>
                  <div class="col-md-6">
                  <p class="text-right"><b>{{currencySymbol}} &nbsp;{{calculatedPension.costOfLiving }}</b></p>
                  </div>
                  </div>
                  <div class="form-group row" appToggle>
                  <div class="col-md-6">
                  <label class="col-form-label toggle-icon noMarginTop"><span>B -</span>{{'calculator.pensionCalculator.result2'|translate}}</label>
                  <p class="futureGapNote formula-section"><span class="glyphicon glyphicon-asterisk"></span>{{'calculator.pensionCalculator.result2'|translate}}</p>
                  </div>
                  <div class="col-md-6">
                  <p class="text-right"><b>{{currencySymbol}} &nbsp;{{calculatedPension.fundNeedOnRetirement }}</b>
                  </p>
                  </div>
                  </div>
                  <div class="form-group row" appToggle>
                  <div class="col-md-6">
                  <label class="col-form-label toggle-icon noMarginTop"><span>C -</span>{{'calculator.pensionCalculator.result3'|translate}}</label>
                  <p class="futureGapNote formula-section"><span class="glyphicon glyphicon-asterisk"></span>{{'calculator.pensionCalculator.result3'|translate}}</p>
                  </div>
                  <div class="col-md-6">
                  <p class="text-right"><b>{{currencySymbol}} &nbsp;{{calculatedPension.lastSalary }}</b></p>
                  </div>
                  </div>
                  <div class="form-group row" appToggle>
                  <div class="col-md-6">
                  <label class="col-form-label toggle-icon noMarginTop"><span>D -</span>{{'calculator.pensionCalculator.result4'|translate}}</label>
                  <p class="futureGapNote formula-section"><span class="glyphicon glyphicon-asterisk"></span>{{'calculator.pensionCalculator.result4'|translate}}</p>
                  </div>
                  <div class="col-md-6">
                  <p class="text-right"><b>{{currencySymbol}}
                  &nbsp;{{calculatedPension.retirementIncomeProjection}}</b></p>
                  </div>
                  </div>
                  <div class="form-group row noBottommargin" appToggle>
                  <div class="col-md-6">
                    <label class="col-form-label toggle-icon noMarginTop"><span>E -</span>{{'calculator.pensionCalculator.result6'|translate}}</label>
                    <p class="futureGapNote formula-section"><span class="glyphicon glyphicon-asterisk"></span>{{'calculator.pensionCalculator.result6'|translate}}</p>
                  </div>
                  <div class="col-md-6">
                  <p class="text-right"><b>{{calculatedPension.replacementRatio}}%</b></p>
                  </div>
                  </div>
                  </div>
                <div class="col-md-12 noBottommargin">
                  <p class="smallFont"><i>**{{'calculator.pensionCalculator.resultnote'|translate}}</i></p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  </div>

